export default __webpack_public_path__ + "static/media/restructuring.cc4e2145.svg";